import {
	ToothPeriodontal,
	ToothPeriodontalItem,
} from '../../../../../graphql/graphql';
import { useCallback, useMemo } from 'react';

interface Props {
	periodontal: ToothPeriodontal;
	setPeriodontal: (periodontal: ToothPeriodontal) => void;
	key: keyof Omit<ToothPeriodontal, '__typename'>;
}

const MAXIMUM_VALUE = 13;

export default function useToothPeriodontalItem({
	periodontal,
	setPeriodontal,
	key,
}: Props) {
	const setPeriodontalItem = useCallback(
		(periodontalItem: ToothPeriodontalItem) => {
			setPeriodontal({
				...periodontal,
				[key]: periodontalItem,
			});
		},
		[setPeriodontal, periodontal],
	);

	const setMargin = (margin: number) => {
		let newDepth = periodontal[key].depth;

		if (margin < 0) {
			const maxAllowedDepth = MAXIMUM_VALUE + margin;
			if (periodontal[key].depth > maxAllowedDepth) {
				newDepth = maxAllowedDepth;
			}
		}

		setPeriodontalItem({
			...periodontal[key],
			margin,
			depth: newDepth,
		});
	};

	const setDepth = (depth: number) => {
		setPeriodontalItem({
			...periodontal[key],
			depth,
		});
	};

	return useMemo(
		() => ({
			[key]: {
				setPeriodontalItem,
				setMargin,
				setDepth,
				getPeriodontalItem: periodontal[key],
			},
		}),
		[periodontal],
	);
}
